import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { useTranslation } from "react-i18next";
import writeXlsxFile from 'write-excel-file'

import './css/showQuestion.css'
import Popups from '../../components/Popups'
import Question from './components/question'
import { TbBorderRadius } from 'react-icons/tb'
import { GET, dateToText, ClassToName, SecoundsToTime, Loader} from '../../inc/Fetch';

export default function AllTaskStatsDownload({ data, setOpen }) {

    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();

    const [loader, setloader] = useState(true)

    async function loadData() {

        let r = await GET(`task/AllMyTaskTasksStats`);

        
        const HEADER_ROW = [
            {
                value: t("class"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30,
            },
            {
                value: t("student"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("login_username"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("tasks_send_show_date"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("tasks_send_timer"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("tasks_score"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            }
            
        ];

        let allWidthData = [
            { width: 15 },
            { width: 25 },
            { width: 15 },
            { width: 20 },
            { width: 12 },
            { width: 12 },
        ]

        const columns = [];
        const tasks = [];
        const DATA_ROW = [];
        const studentAvg = [];
        r?.tasks?.map(v => {

            tasks.push(v?.title);
            columns.push(allWidthData);

            let inArray = [HEADER_ROW];
            let students = r?.students?.filter(d => d?.classes[0] == v?.classes);

            students?.map((v2, k2) => {

                studentAvg[v2?._id] = [];

                let results = r?.students_results?.filter(d => d?.task?._id == v?._id && d?.user?._id == v2?._id);
                let resAnswers = {};
                if (results?.length) {
                    resAnswers = results[0];
                }

                inArray.push(
                    [
                        {
                            type: String,
                            value: ClassToName({ classes: v?.classes, string: true}),
                            align: "center",
                            alignVertical:"center",
                            height:30
                        },
                        {
                            type: String,
                            value: v2?.name,
                            align: "center",
                            alignVertical:"center",
                            height:30
                        },
                        {
                            type: String,
                            value: v2?.user,
                            align: "center",
                            alignVertical:"center",
                            height:30
                        },
                        {
                            value: resAnswers?.date ? dateToText(resAnswers?.date, "datetime") : "--",
                            align: "center",
                            alignVertical:"center",
                            height:30
                        },
                        {
                            type: String,
                            value: resAnswers?.timer ? SecoundsToTime({ time: resAnswers?.timer }) : "--",
                            align: "center",
                            alignVertical:"center",
                            height:30
                        },
                        {
                            type: String,
                            value: resAnswers?.score ? `${resAnswers?.score}%` : '--',
                            align: "center",
                            alignVertical:"center",
                            height:30
                        }
                    ]
                );

                if (resAnswers?.score) {
                    studentAvg[v2?._id].push(resAnswers?.score);
                }

            });
            

            DATA_ROW.push(inArray);
            

        });

        
        tasks.push(t("avg"));
        columns.push([
            { width: 15 },
            { width: 25 },
            { width: 15 },
            { width: 20 }
        ]);

        const HEADER_ROW2 = [
            {
                value: t("class"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30,
            },
            {
                value: t("student"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("login_username"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("avg"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            }
            
        ];

        let inArray = [HEADER_ROW2];
        
        Object.keys(studentAvg)?.map(v3 => {
            let avg = 0;
            let vals = studentAvg[v3];
            if (vals?.length) {
                vals?.map(v4 => {
                    avg += v4;
                });
            }

            if (!avg) {
                avg = "--"
            } else {
                avg = avg / vals?.length
            }

            let student = r?.students?.filter(d => `${d?._id}` == v3);
            if (student?.length) {
                student = student[0];
            }
            inArray.push(
                [
                    {
                        type: String,
                        value: ClassToName({ classes: student?.classes[0], string: true}),
                        align: "center",
                        alignVertical:"center",
                        height:30
                    },
                    {
                        type: String,
                        value: student?.name,
                        align: "center",
                        alignVertical:"center",
                        height:30
                    },
                    {
                        type: String,
                        value: student?.user,
                        align: "center",
                        alignVertical:"center",
                        height:30
                    },
                    {
                        value: avg != "--" ? `${avg}%` : "--",
                        align: "center",
                        alignVertical:"center",
                        height:30
                    }
                ]
            );

            DATA_ROW.push(inArray);

        });

        await writeXlsxFile(DATA_ROW, {
            columns,
            sheets: tasks,
            fileName: 'file.xlsx',
            fontSize: 12,
            height:30,
            rightToLeft: true
        });

        setloader(false);

        setTimeout(() => {
            close();
        }, 300);

    }

    useEffect(() => {
        loadData();
    }, []);

    
    return (
        <div>
            {loader && <Loader />}
        </div>
    )
}
